__turbopack_context__.v({
  "account-navigation-button-collapse": "account-navigation-module-scss-module__yJV0dW__account-navigation-button-collapse",
  "avatar": "account-navigation-module-scss-module__yJV0dW__avatar",
  "avatarImage": "account-navigation-module-scss-module__yJV0dW__avatarImage",
  "avatarPlaceholder": "account-navigation-module-scss-module__yJV0dW__avatarPlaceholder",
  "button": "account-navigation-module-scss-module__yJV0dW__button",
  "buttonClosing": "account-navigation-module-scss-module__yJV0dW__buttonClosing",
  "buttonCollapsed": "account-navigation-module-scss-module__yJV0dW__buttonCollapsed",
  "buttonExpanded": "account-navigation-module-scss-module__yJV0dW__buttonExpanded",
  "inner": "account-navigation-module-scss-module__yJV0dW__inner",
  "innerClosing": "account-navigation-module-scss-module__yJV0dW__innerClosing",
  "innerCollapsed": "account-navigation-module-scss-module__yJV0dW__innerCollapsed",
  "innerExpanded": "account-navigation-module-scss-module__yJV0dW__innerExpanded",
  "name": "account-navigation-module-scss-module__yJV0dW__name",
  "nav-user-inner-collapse": "account-navigation-module-scss-module__yJV0dW__nav-user-inner-collapse",
  "nav-user-text-collapse": "account-navigation-module-scss-module__yJV0dW__nav-user-text-collapse",
  "text": "account-navigation-module-scss-module__yJV0dW__text",
  "textClosing": "account-navigation-module-scss-module__yJV0dW__textClosing",
});
